import Grid from '@material-ui/core/Grid'
import React from 'react'

export default (props) => {
  const address = props.addressObject
  if (!address) return null
  return (
    <Grid className="text" spacing={0}>
      <React.Fragment>
        <Grid item xs={12}>
          {address.address1}
        </Grid>
        <Grid item xs={12}>
          {address.address2}
        </Grid>
        <Grid item xs={12}>
          {address.address3}
        </Grid>
        <Grid item xs={12}>
          {address.city}, {address.state} {address.zip}
        </Grid>
      </React.Fragment>
    </Grid>
  )
}
